import React from 'react';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import { DishSelect } from './components/DishSelect';
import { ResetBtn } from './components/ResetBtn';
import style from './ChangePositionControlPanel.module.scss';

export const ChangePositionControlPanel: React.FC = () => {
	return (
		<div className={style.container} data-test="ChangePositionControlPanel">
			<div className={style.selectWrapper}>
				<CustomerSelect />
				<RestaurantSelect />
				<DishSelect />
			</div>
			<ResetBtn />
		</div>
	);
};
